import React, { useState } from 'react';
import { DynamicTranslationsGrid } from './DynamicTranslationsGrid';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { useGlobalizationContext, useTranslation, useGetIndexes, useGetLocales } from '@cs-cms/state-management';
import { CpsIndex, ENGLISH_LOCALE } from '@cs-cms/types';
import { CpsTabs } from '../../../common/CpsTabs';

export const FieldTranslationsManagement: React.FC = () => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);
  const [activeLocaleNumber, setActiveLocaleNumber] = useState(0);
  const { data: indexes } = useGetIndexes();
  const [selectedIndex, setSelectedIndex] = useState<CpsIndex | null>(null);
  const { data: locales } = useGetLocales();

  const availableLocales = locales ?? [];
  const safeActiveLocaleNumber =
    availableLocales.length > 0 && activeLocaleNumber >= availableLocales.length ? 0 : activeLocaleNumber;
  const activeLocale = availableLocales[safeActiveLocaleNumber];
  const englishLocale = availableLocales.find(
    locale => locale.name === ENGLISH_LOCALE || locale.name.includes(ENGLISH_LOCALE)
  );
  const initialSelectedIndex = selectedIndex ?? indexes?.[0] ?? null;

  return (
    <>
      <>
        <div className="translationsTitleContainer">
          <h1>{translate('custom.settings.adminCenter.translationManagement.fieldTranslations.title')}</h1>
          <DropDownList
            data={indexes || []}
            label={translate('custom.toolbar.index')}
            value={initialSelectedIndex}
            onChange={e => setSelectedIndex(e.target.value)}
            textField="displayName"
            dataItemKey="id"
            size={'medium'}
            className="translationsIndexDropdown"
          />
        </div>
        <p>{translate('custom.settings.adminCenter.translationManagement.fieldTranslations.description')}</p>
      </>

      <div className="translationsContent">
        <CpsTabs
          selected={safeActiveLocaleNumber}
          onSelect={setActiveLocaleNumber}
          items={availableLocales.map(locale => ({
            id: String(locale.id),
            title: locale.name
          }))}
        >
          <DynamicTranslationsGrid
            activeLocale={activeLocale}
            englishLocale={englishLocale}
            selectedIndex={selectedIndex ?? initialSelectedIndex}
          />
        </CpsTabs>
      </div>
    </>
  );
};
